import BannerLegal from '@/components/common/banner-legal/BannerLegal.vue';
import Navbar from '@/components/common/navbar/Navbar.vue';
import Support from '@/components/common/support/Support.vue';
import { titleTemplate } from '@/helpers/meta/title-template';
import LandingFooter from '@/modules/landing/components/footer/LandingFooter.vue';
import LandingRisks from '@/modules/landing/components/risks/LandingRisks.vue';
import { State } from '@/store/models';
import { MetaInfo } from 'vue-meta';
import { Component, Vue } from 'vue-property-decorator';
import { Getter, State as StateClass } from 'vuex-class';
import { intercom } from '../../../whitelabel.config';

@Component({
  components: {
    Support,
    BannerLegal,
    Navbar,
    LandingRisks,
    LandingFooter,
  },
})
export default class News extends Vue {
  metaInfo(): MetaInfo {
    return {
      title: titleTemplate(this.$t('meta.posts.title').toString()),
    };
  }

  intercom = intercom;

  @StateClass user!: State['user'];
  @Getter isUserLoggedIn!: boolean;

  get tabs(): { title: string, routeName: string, icon: string[] }[] {
    return [
      { title: this.$t('common.news').toString(), routeName: 'news-articles', icon: ['fa', 'book'] },
      { title: this.$t('common.background').toString(), routeName: 'news-background', icon: ['fa', 'book'] },
      { title: this.$t('common.press').toString(), routeName: 'news-press', icon: ['fa', 'book'] },
    ];
  }

  get userLoggedIn(): boolean {
    return this.isUserLoggedIn;
  }

  /**
   * Return if tab is active.
   */
  isActiveTab(tabRouteName: string): boolean {
    return (this.$route.name || '').startsWith(tabRouteName);
  }
}
